<template>
  <nav class="breadcrumbs">
    <component
      :is="componentIs(path)"
      v-for="path in breadcrumbs"
      :key="path.fullPath"
      :class="{ breadcrumbs__link: path.isLink }"
      :to="breadcrumbPath(path.fullPath, path.isLink)"
    >
      {{ path.name }}
    </component>
  </nav>
</template>

<script lang="ts" setup>
import type { Breadcrumb } from '~/types'

interface Props {
  textOverride?: string
  isTrimmed?: boolean
  capitalizeEachWord?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  textOverride: '',
  isTrimmed: true,
})

const localePath = useLocalePath()

const componentIs = (path: Breadcrumb) =>
  path.isLink ? resolveComponent('NuxtLink') : 'div'

const breadcrumbPath = (fullPath: string, isLink: boolean) =>
  isLink ? localePath(`/${fullPath}`) : undefined

const { breadcrumbs } = useBreadcrumbs(
  props.isTrimmed,
  props.textOverride,
  props.capitalizeEachWord,
)
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: var(--space32);
  font-size: var(--font-size-paragraph-s);

  @media (min-width: $breakpoint-md) {
    align-items: center;
  }

  &__link {
    color: var(--cobalt-600);
    display: flex;
    align-items: center;
    text-underline-offset: 6px;

    &:not(:last-child)::after {
      @include icon('@/assets/icons/12-chevron-breadcrumbs.svg', 10px, 10px);

      content: '';
      position: relative;
      padding: 0 20px;
    }
  }
}
</style>
